<template>
  <div class="upload-files">
    <el-upload
      v-if="previewUrl.length < limit"
      ref="upload"
      action=""
      :show-file-list="false"
      class="avatar-uploader"
      :http-request="handleChange"
      :before-upload="beforeAvatarUpload"
    >
      <!--      <div class="upload-btn" v-loading="loading">-->
      <!--        <i class="el-icon-plus"></i>-->
      <!--      </div>-->
      <el-image
        :src="defaultImage"
        class="default-image"
        v-loading="loading"
      ></el-image>
    </el-upload>

    <div class="file-list" v-for="(item, index) in previewUrl" :key="index">
      <div class="file-list-title">
        <el-image
          :src="item"
          style="width: 0.8rem; height: 0.8rem"
          fit="cover"
          :preview-src-list="[item]"
        ></el-image>
      </div>
      <span class="icon-delete" @click="del(index, item)"
        ><i class="el-icon-delete"></i
      ></span>
    </div>
  </div>
</template>

<script>
import { getShortToken, uploadFile } from "@/views/commonApi";

export default {
  name: "UploadFiles2",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: {
      type: [],
      default: () => {
        return [];
      },
    },
    limit: {
      type: Number,
      default: 3,
    },
    maxSize: {
      type: Number,
      default: 20,
    },
  },
  data() {
    return {
      defaultImage: require("@/assets/imgs/download.png"),
      imageUrl: "",
      loading: false,
      previewUrl: [],
    };
  },
  computed: {
    fileList: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("change", val);
      },
    },
  },
  watch: {
    value(val) {
      this.getShortImageToken(val);
    },
  },
  methods: {
    del(index, item) {
      if (item.id) {
        this.$emit("deleteItem", index, item);
      } else {
        this.previewUrl.splice(index, 1);
        this.fileList.splice(index, 1);
      }
    },
    // 图片上传之前的
    beforeAvatarUpload(file) {
      // console.log("file", file);
      const max = file.size / 1024 / 1024 < Number(this.maxSize);
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg";
      if (!isJPG) {
        this.$message.error("上传图片只能是 jpg,jpeg,pn 格式!");
      }
      if (!max) {
        this.$message.error(`上传图片大小不能超过 ${this.maxSize}MB!`);
      }
      return max && isJPG;
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        let fileResult = "";
        reader.readAsDataURL(file); //开始转
        reader.onload = function () {
          fileResult = reader.result;
        }; //转 失败
        reader.onerror = function (error) {
          reject(error);
        }; //转 结束  咱就 resolve 出去
        reader.onloadend = function () {
          resolve(fileResult);
        };
      });
    },
    handleChange(file, fileList) {
      this.uploadFiles(file);
    },
    uploadFiles(file) {
      let that = this;
      // console.log("file", file);
      let files = file.file;
      let formData = new FormData();
      formData.append("file", files);
      that.loading = true;
      uploadFile(formData)
        .then((res) => {
          that.loading = false;
          if (res.code === 200) {
            this.fileList.push(res.data.fileId);
            this.previewUrl.push(
              process.env.VUE_APP_BASE_PATH +
                process.env.VUE_APP_REMOTE_API +
                "/pmy/file/sys-file/download?fileId=" +
                res.data.fileId
            );
            that.$refs.upload.clearFiles();
            that.$emit("change", this.fileList);
          }
        })
        .catch((err) => {
          that.loading = false;
          // console.log(err);
        });
    },
    getShortImageToken(fileId) {
      let url =
        process.env.VUE_APP_BASE_PATH +
        process.env.VUE_APP_REMOTE_API +
        "/pmy/file/sys-file/download?fileId=" +
        fileId;
      return url;
    },
  },
};
</script>
<style lang="scss"></style>
<style lang="scss" scoped>
.upload-files {
  display: flex;
  align-items: center;
  .el-icon-plus {
    font-size: 0.3rem;
    color: #eaeff5;
  }
  .upload-btn {
    width: 1rem;
    height: 1rem;
    background: #ffffff;
    border-radius: 0.04rem;
    border: 0.01rem solid #eaeff5;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    &:hover {
      border-color: #516ae9;
      color: #516ae9;
    }
  }
  .file-list {
    display: flex;
    align-items: center;
    position: relative;
    margin-left: 0.1rem;
    .file-list-title {
      width: 1rem;
      height: 1rem;
      font-size: 0.16rem;
      color: #516ae9;
      &:hover {
        text-decoration: underline;
      }
    }
    .icon-delete {
      display: flex;
      align-items: center;
      position: absolute;
      right: -0.1rem;
      top: -0.1rem;
      z-index: 10;
    }
    .el-icon-delete {
      color: rgba(255, 0, 0, 0.86);
      font-size: 0.2rem;
      margin-left: 0.1rem;
      &:hover {
        color: red;
        cursor: pointer;
      }
    }
  }
  .default-image {
    width: 0.8rem;
    height: 0.8rem;
  }
}
</style>
